<!--
  The one announcement of lazy work (logic/pending): a polite status, empty
  while a figure is still counting (the region it sits in carries
  aria-busy, and its own words say how far along it is), that says `done`
  once when counting ends. Nothing on the ticks between, and nothing for a
  figure that was whole when shown.
-->
<script lang="ts">
  import { settled } from '../logic/pending';

  interface Props {
    /** Whether the figure is still counting (from the stores' state, not a timer). */
    busy: boolean;
    /** What to say once everything is counted ("All 362 changed files counted."). */
    done: string;
  }
  let { busy, done }: Props = $props();

  let said = $state('');
  let was = false;
  $effect.pre(() => {
    const now = busy;
    const words = settled(was, now, done);
    if (words) said = words;
    else if (now) said = '';
    was = now;
  });
</script>

<span class="sr-only" role="status" aria-live="polite">{said}</span>
